import {
  constructMethodCallHeaders,
  constructMethodCallUri,
  encodeMethodCallBody,
  httpResponseBodyParse,
  httpResponseCodeToEnum,
  ResponseType,
  XRPCError,
  XRPCResponse
} from "./xrpc-utils.js";
export const isErrorResponse = (value, names) => {
  if (!value) {
    return false;
  }
  const errType = typeof value.error;
  const msgType = typeof value.message;
  return (errType === "undefined" || errType === "string") && (msgType === "undefined" || msgType === "string") && (!names || names.includes(value.error));
};
export const defaultFetchHandler = async (httpUri, httpMethod, httpHeaders, httpReqBody, signal) => {
  try {
    const reqInit = {
      signal,
      method: httpMethod,
      headers: httpHeaders,
      body: encodeMethodCallBody(httpHeaders, httpReqBody),
      duplex: "half"
    };
    const res = await fetch(httpUri, reqInit);
    const resBody = await res.arrayBuffer();
    return {
      status: res.status,
      headers: Object.fromEntries(res.headers.entries()),
      body: httpResponseBodyParse(res.headers.get("content-type"), resBody)
    };
  } catch (e) {
    throw new XRPCError(ResponseType.Unknown, String(e));
  }
};
export class XRPC {
  constructor(serviceUri, fetch2 = defaultFetchHandler) {
    this.serviceUri = serviceUri;
    this.fetch = fetch2;
  }
  get(nsid, options) {
    return this.#call({ type: "get", method: nsid, ...options });
  }
  call(nsid, options) {
    return this.#call({ type: "post", method: nsid, ...options });
  }
  async #call(options) {
    const { type, method, params, data, encoding, headers = {}, signal } = options;
    const httpUri = constructMethodCallUri(method, this.serviceUri, params);
    const httpHeaders = constructMethodCallHeaders(headers, type, data, encoding);
    const res = await this.fetch(httpUri, type, httpHeaders, data, signal);
    const resCode = httpResponseCodeToEnum(res.status);
    if (resCode === ResponseType.Success) {
      return new XRPCResponse(res.body, res.headers);
    } else {
      if (res.body && isErrorResponse(res.body)) {
        throw new XRPCError(resCode, res.body.error, res.body.message);
      } else {
        throw new XRPCError(resCode);
      }
    }
  }
}
